import React from "react";
import PaymentsWidget from "../components/payments";

function PromoCodePage(props) {
  return <PaymentsWidget mode="page" />;
}

export default PromoCodePage;



// WEBPACK FOOTER //
// ./src/containers/promo-code.js